import React, { useRef, useEffect, useState } from 'react';
import ProTable from '@ant-design/pro-table';
import {
  Button,
  Tag,
  Modal,
  Form,
  Space,
  Input,
  DatePicker,
  message,
  Radio,
} from 'antd';
import { history } from 'umi';
import {
  serviceList,
  neverCompleteClass,
  firstClassLoss,
  expiring,
  customerReplies,
  saveTrack,
} from '@/services/userManager';
import { guuid } from '@/utils/utils';

import moment from 'moment';

const { TextArea } = Input;

/**
 *  本应和followPage一致，服务端字段定义差异过大，拆成2个
 */
const FollowPage = (props) => {
  // 1.未完成首课 2.首课流失 3.即将到期
  // eslint-disable-next-line react/prop-types
  const { type } = props;
  const actionRef = useRef();
  /// 添加跟进
  const [addFollowForm] = Form.useForm();
  const [addFollowModalVisible, setAddFollowModalVisible] = useState(false);
  const [customerRepliesList, setCustomerRepliesList] = useState([]);
  const [sportsWillingnessesList, setSportsWillingnessesList] = useState([]);
  const [editRecord, setEditRecord] = useState();
  // eslint-disable-next-line no-unused-vars
  const [requestList, setRequestList] = useState([
    serviceList,
    neverCompleteClass,
    firstClassLoss,
    expiring,
  ]);
  function disabledDate(current) {
    return current && current > moment().subtract(1, 'days').endOf('day');
  }
  const disabledDateTime = () => ({
    disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 23],
  });
  // 档案 todo
  const goRecord = (record) => {
    history.push(`/user/record?id=${record.userId}&phone=${record.phone}`);
  };
  const newFollow = (record) => {
    setAddFollowModalVisible(true);
    setEditRecord(record);
  };
  // 获取回复。意愿列表
  const queryCustomerReplies = async () => {
    customerReplies({
      requestData: {},
    }).then(({ code, data, msg }) => {
      if (code === '00000') {
        setCustomerRepliesList(data.customerReplies || []);
        setSportsWillingnessesList(data.sportsWillingnesses || []);
      } else {
        message.error(msg);
      }
    });
  };
  const addFollowModalOkAction = () => {
    addFollowForm.validateFields().then((values) => {
      const param = {
        trackType: 2,
        userId: editRecord.userId,
        ...values,
        resentTrackTime: moment(values.resentTrackTime).format(
          'YYYY-MM-DD HH:mm',
        ),
        nextTrackTime: values.nextTrackTime
          ? moment(values.nextTrackTime).format('YYYY-MM-DD HH:mm')
          : undefined,
      };
      saveTrack({
        requestData: param,
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('添加成功！');
        } else {
          message.error(msg);
        }
        // 刷新跟进
        actionRef.current?.reload();
        setAddFollowModalVisible(false);
        addFollowForm.resetFields();
        setEditRecord(undefined);
      });
    });
  };
  const addFollowModalCancelAction = () => {
    addFollowForm.resetFields();
    setAddFollowModalVisible(false);
  };
  const addFollowModalView = () => {
    return (
      <Modal
        title="添加跟进"
        visible={addFollowModalVisible}
        onCancel={() => addFollowModalCancelAction(false)}
        footer={[]}
        width={800}
      >
        <Form
          form={addFollowForm}
          name="removeClassForm"
          className="form"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <Form.Item
            name="resentTrackTime"
            label="最近跟进时间"
            initialValue={moment()}
            rules={[
              {
                required: true,
                message: '请选择最近跟进时间!',
              },
            ]}
          >
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm"
              disabledDate={disabledDate}
            />
          </Form.Item>

          <Form.Item
            name="nextTrackTime"
            label="下次跟进时间"
            initialValue={moment().add(2, 'days')}
          >
            <DatePicker
              showNow={false}
              disabledTime={disabledDateTime}
              showTime
              minuteStep={10}
              format="YYYY-MM-DD HH:mm"
            />
          </Form.Item>

          <Form.Item
            name="customerReply"
            label="客户回复"
            rules={[
              {
                required: true,
                message: '请选择客户回复!',
              },
            ]}
          >
            <Radio.Group buttonStyle="solid">
              {customerRepliesList.map((item) => {
                return (
                  <Radio.Button key={guuid()} value={item?.customerReply}>
                    {item?.desc}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </Form.Item>

          <Form.Item name="trackInfo" label="其他备注说明">
            <TextArea
              showCount
              placeholder="其他备注说明，500个字符以内选填"
              maxLength={500}
            />
          </Form.Item>

          <Form.Item
            name="sportsWillingness"
            label="运动意愿"
            rules={[
              {
                required: true,
                message: '请选择客户回复!',
              },
            ]}
          >
            <Radio.Group buttonStyle="solid">
              {sportsWillingnessesList.map((item) => {
                return (
                  <Radio.Button key={guuid()} value={item?.sportsWillingness}>
                    {item?.desc}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" onClick={addFollowModalOkAction}>
              提交
            </Button>
            <Button
              htmlType="button"
              style={{ margin: '0 16px' }}
              onClick={addFollowModalCancelAction}
            >
              取消
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const appointTypeArray = {
    0: '暂未定义',
    1: '侧边栏预约',
    2: '后台预约',
    3: '教练一键开课',
    4: '用户自主约课',
    5: '服务号约课',
    6: '定时提醒约课',
  };
  const categoryTypeArray = {
    0: '暂未定义',
    1: '私教课',
    2: 'AI自练课',
  };

  const columns = [
    {
      title: '用户',
      dataIndex: 'wxNickName',
      key: 'wxNickName',
      hideInSearch: true,
      render: (_, record, index, action) => {
        return (
          <div>
            <div>{record.phone}</div>
            <div style={{ fontSize: 12, color: 'gray' }}>{record.wxName}</div>
          </div>
        );
      },
    },
    {
      title: '手机号/微信昵称',
      dataIndex: 'phone',
      key: 'phone',
      hideInTable: true,
    },
    {
      title: '最近订单',
      dataIndex: 'recentOrder',
      key: 'recentOrder',
      hideInSearch: true,
    },
    {
      title: '私教剩余',
      dataIndex: 'ptClassCnt',
      key: 'ptClassCnt',
      hideInSearch: true,
    },
    {
      title: '私教到期',
      dataIndex: 'ptExpire',
      key: 'ptExpire',
      hideInSearch: true,
      hideInTable: type !== 3,
    },
    {
      title: 'AI到期',
      dataIndex: 'aiExpire',
      key: 'aiExpire',
      hideInSearch: true,
    },
    {
      title: '已加RPA群/设置提醒',
      dataIndex: 'groupNames',
      key: 'groupNames',
      hideInSearch: true,
      hideInTable: type === 3,
      render: (text, record) => {
        return (
          <div>
            <Space direction="vertical">
              <div>
                {(record?.groupNames || []).map((item) => {
                  return <Tag key={guuid()}>{item?.groupName}</Tag>;
                })}
              </div>
              <div>
                {record?.weeklyPlanName ? (
                  <Tag color={'blue'}>{record?.weeklyPlanName}</Tag>
                ) : (
                  ''
                )}
                {record?.remindTime ? (
                  <Tag color={'orange'}>{record?.remindTime}</Tag>
                ) : (
                  ''
                )}
              </div>
            </Space>
          </div>
        );
      },
    },
    {
      title: 'AI/私教累计完课',
      dataIndex: 'aiPtTotal',
      key: 'aiPtTotal',
      hideInSearch: true,
      hideInTable: type !== 3,
      render: (text, record) => {
        return (
          <div>
            <Space direction="vertical">
              <label>{record?.aiPtTotal ?? '-'}</label>
              {record?.subsPlanName ? <Tag>{record?.subsPlanName}</Tag> : ''}
            </Space>
          </div>
        );
      },
    },
    {
      title: '上次完课',
      dataIndex: 'upCategory',
      key: 'upCategory',
      hideInSearch: true,
      hideInTable: type === 1,
      render: (text, record) => {
        return (
          <div>
            <Space direction="vertical">
              <div>
                {record?.lastDays ? (
                  <Tag color={'orange'}>{record?.lastDays}</Tag>
                ) : (
                  ''
                )}

                {categoryTypeArray?.[record?.upCategory] ? (
                  <Tag color={'green'}>
                    {categoryTypeArray?.[record?.upCategory]}
                  </Tag>
                ) : (
                  ''
                )}

                <Tag color={'green'}>
                  上课时长:
                  {record?.upClassDuration ? record?.upClassDuration : '-'}
                </Tag>
              </div>
              <div>
                <label>{record?.upClassDurationDate}</label>
              </div>
            </Space>
          </div>
        );
      },
    },
    {
      title: '加企微时间',
      dataIndex: 'addStaffTime',
      key: 'addStaffTime',
      hideInSearch: true,
      hideInTable: type !== 1,
    },
    {
      title: '下次上课',
      dataIndex: 'nextCategory',
      key: 'nextCategory',
      hideInSearch: true,
      render: (text, record) => {
        return (
          <div>
            <Space direction="vertical">
              <div>
                {categoryTypeArray?.[record?.nextCategory] ? (
                  <Tag color={'green'}>
                    {categoryTypeArray?.[record?.nextCategory]}
                  </Tag>
                ) : (
                  ''
                )}
                {appointTypeArray?.[record?.appointType] ? (
                  <Tag color={'green'}>
                    {appointTypeArray?.[record?.appointType]}
                  </Tag>
                ) : (
                  ''
                )}
              </div>
              <div>
                <label>{record?.nextClassDurationDate}</label>
              </div>
            </Space>
          </div>
        );
      },
    },

    {
      title: '按最近订单排序',
      dataIndex: 'orderBy',
      key: 'orderBy',
      valueType: 'select',
      hideInTable: true,
      hideInSearch: type !== 1,
      valueEnum: {
        // 0: {
        //     text: '默认排序',
        // },
        1: {
          text: '正序',
        },
        2: {
          text: '倒序',
        },
      },
    },
    {
      title: '到期状态',
      dataIndex: 'expireStatus',
      key: 'expireStatus',
      valueType: 'select',
      hideInTable: true,
      hideInSearch: type !== 3,
      valueEnum: {
        0: {
          text: '未到期',
        },
        1: {
          text: '已到期',
        },
      },
    },

    {
      title: '操作',
      valueType: 'option',
      key: 'option',
      fixed: 'right',
      width: '100',
      render: (text, record, _, action) =>
        type !== 3
          ? [
              <a key="newFollow" onClick={() => newFollow(record)}>
                跟进
              </a>,
              <a key="goRecord" onClick={() => goRecord(record)}>
                档案
              </a>,
            ]
          : [
              <a key="goRecord" onClick={() => goRecord(record)}>
                档案
              </a>,
            ],
    },
  ];

  useEffect(() => {
    queryCustomerReplies();
  }, []);

  return (
    <div>
      <ProTable
        columns={columns}
        actionRef={actionRef}
        request={async (params) => {
          const { data, page, code, msg } = await requestList[type]({
            requestData: { ...params },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            message.error(msg);
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        editable={{
          type: 'multiple',
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos',
          persistenceType: 'localStorage',
        }}
        rowKey="userId"
        search={{
          labelWidth: '120',
          defaultCollapsed: false,
        }}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [5, 10, 20, 30],
        }}
        dateFormatter="string"
        toolBarRender={() => []}
      />

      {addFollowModalView()}
    </div>
  );
};

export default FollowPage;
